import type { Config } from "wagmi"
import { frontendUserManageMinimalPoolAbi } from "@/domains/abis/frontend-user-manage-minimal-pool"
import { LcAddress } from "@/domains/core"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { readContract } from "@wagmi/core"
import { Address } from "viem"

export type ScalensUserManageMinimalPoolInfo = {
  minimalPoolAddress: LcAddress
  whoAddress: LcAddress
  routerAddress: LcAddress
  gaugeTotalSupply: bigint // ✅
  poolReserve0: bigint // ✅
  poolReserve1: bigint // ✅
  poolTotalSupply: bigint // ✅
  userGaugeBalance: bigint // ✅
  userGaugeReserve0: bigint // ✅
  userGaugeReserve1: bigint // ✅
  userPoolBalance: bigint // ✅
  userPoolGaugeAllowance: bigint // ✅
  userPoolReserve0: bigint // ✅
  userPoolReserve1: bigint // ✅
  userPoolRouterAllowance: bigint // ✅
  userToken0Balance: bigint // ✅
  userToken0RouterAllowance: bigint // ✅
  userToken1Balance: bigint // ✅
  userToken1RouterAllowance: bigint // ✅
}

type Props = {
  config: Config
  pool: MinimalPoolStore
  scalensUserManageMinimalPool: LcAddress
  who: LcAddress
  routerAddress: LcAddress
}

export const scalensUserManageMinimalPoolInfo = async ({
  config,
  pool,
  scalensUserManageMinimalPool,
  who,
  routerAddress,
}: Props): Promise<ScalensUserManageMinimalPoolInfo | undefined> => {
  if (!pool) {
    return undefined
  }

  const response = (await readContract(config, {
    abi: frontendUserManageMinimalPoolAbi,
    address: scalensUserManageMinimalPool.toViemAddress(),
    functionName: "userManageMinimalPoolInfo",
    args: [pool.address.toViemAddress(), who.toViemAddress(), routerAddress.toViemAddress()],
  })) as {
    A: [Address, Address, Address]
    N: [
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
      bigint,
    ]
  }

  const item: ScalensUserManageMinimalPoolInfo = {
    minimalPoolAddress: new LcAddress(response.A[0]),
    whoAddress: new LcAddress(response.A[1]),
    routerAddress: new LcAddress(response.A[2]),
    poolReserve0: response.N[0],
    poolReserve1: response.N[1],
    poolTotalSupply: response.N[2],
    gaugeTotalSupply: response.N[3],
    userToken0Balance: response.N[4],
    userToken1Balance: response.N[5],
    userPoolBalance: response.N[6],
    userGaugeBalance: response.N[7],
    userToken0RouterAllowance: response.N[8],
    userToken1RouterAllowance: response.N[9],
    userPoolGaugeAllowance: response.N[10],
    userPoolRouterAllowance: response.N[11],
    userPoolReserve0: response.N[12],
    userPoolReserve1: response.N[13],
    userGaugeReserve0: response.N[14],
    userGaugeReserve1: response.N[15],
  }

  return item
}
